<template>
  <tr
    class="ActivityReportListItem"
    @click="navigateToReport()">
    <td>Activity report</td>
    <td>{{ month }}</td>
    <td>{{ due }}</td>
    <td><ReportStatus :status="status" /></td>
    <td>
      <Icon
        name="arrow"
        direction="right" />
    </td>
  </tr>
</template>

<script>
import moment from "moment";
import ReportStatus from "@/components/ReportStatus";
export default {
  components: { ReportStatus },
  data: function () {
    return {};
  },

  props: {
    report: {
      type: Object,
      required: true,
    },
  },

  mounted() {},

  methods: {
    navigateToReport() {
      this.$router.push({
        name: "activity-report",
        params: {
          id: this.report.id,
        },
      });
    },
  },

  computed: {
    month() {
      return moment(this.report.periodStart).format("MMMM");
    },

    status() {
      return this.report.status;
    },

    due() {
      return moment(this.report.periodEnd).format("ll");
    },
  },

  filters: {},
};
</script>

<style lang="scss" scoped>
.ActivityReportListItem {
  cursor: pointer;

  td:first-child {
    font-weight: bold;
    color: var(--blue-purple);
  }

  td:last-child {
    opacity: 0.5;
  }
}
</style>
